// VzmDateField.js
// Copyright to Lab is Fun, Inc. All rights reserved. 2024.
//import React, { useEffect, useState } from "react";
import { TextField } from '@mui/material';
import { AppWord, InputType } from "../value/AppConst";
import ValueMisc from "../value/ValueMisc";



export default function VzmDateField({
    dict,
    value, // YYYY-MM-DD
    disabled,
    onChange,
    error,
    size,
    onFocused,
}) {

    const fieldInputProps = dict.inputPropsStyle ? {style:dict.inputPropsStyle} : undefined;

    return(
        <TextField id={dict.id} size={size || dict.size || AppWord.SMALL}
            label={dict.label}
            type={InputType.date}
            required={dict.required}
            value={value || ValueMisc.getYMD()}
            error={error}
            helperText={dict.errorHelp ? dict.errorHelp : undefined}
            onChange={(e)=>onChange(dict.id, e.target.value, false)}
            onFocus={()=>{if(onFocused) onFocused(dict)}}
            inputProps={fieldInputProps}
            disabled={disabled?true:false}
        />
    );
}
